import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import aiosellMapping4f4b2d from './aiosell-mapping'
/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::index
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:31
* @route '/rate-plans'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/rate-plans',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::index
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:31
* @route '/rate-plans'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::index
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:31
* @route '/rate-plans'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::index
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:31
* @route '/rate-plans'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::index
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:31
* @route '/rate-plans'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::index
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:31
* @route '/rate-plans'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::index
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:31
* @route '/rate-plans'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::save
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:97
* @route '/rate-plans'
*/
export const save = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: save.url(options),
    method: 'put',
})

save.definition = {
    methods: ["put"],
    url: '/rate-plans',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::save
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:97
* @route '/rate-plans'
*/
save.url = (options?: RouteQueryOptions) => {
    return save.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::save
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:97
* @route '/rate-plans'
*/
save.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: save.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::save
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:97
* @route '/rate-plans'
*/
const saveForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: save.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::save
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:97
* @route '/rate-plans'
*/
saveForm.put = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: save.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

save.form = saveForm

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::toggleActive
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:115
* @route '/rate-plans/{ratePlan}/active'
*/
export const toggleActive = (args: { ratePlan: string | { id: string } } | [ratePlan: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: toggleActive.url(args, options),
    method: 'patch',
})

toggleActive.definition = {
    methods: ["patch"],
    url: '/rate-plans/{ratePlan}/active',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::toggleActive
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:115
* @route '/rate-plans/{ratePlan}/active'
*/
toggleActive.url = (args: { ratePlan: string | { id: string } } | [ratePlan: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { ratePlan: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { ratePlan: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            ratePlan: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        ratePlan: typeof args.ratePlan === 'object'
        ? args.ratePlan.id
        : args.ratePlan,
    }

    return toggleActive.definition.url
            .replace('{ratePlan}', parsedArgs.ratePlan.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::toggleActive
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:115
* @route '/rate-plans/{ratePlan}/active'
*/
toggleActive.patch = (args: { ratePlan: string | { id: string } } | [ratePlan: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: toggleActive.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::toggleActive
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:115
* @route '/rate-plans/{ratePlan}/active'
*/
const toggleActiveForm = (args: { ratePlan: string | { id: string } } | [ratePlan: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggleActive.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::toggleActive
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:115
* @route '/rate-plans/{ratePlan}/active'
*/
toggleActiveForm.patch = (args: { ratePlan: string | { id: string } } | [ratePlan: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggleActive.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

toggleActive.form = toggleActiveForm

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::dateRate
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:122
* @route '/rate-plans/date-rate'
*/
export const dateRate = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: dateRate.url(options),
    method: 'put',
})

dateRate.definition = {
    methods: ["put"],
    url: '/rate-plans/date-rate',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::dateRate
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:122
* @route '/rate-plans/date-rate'
*/
dateRate.url = (options?: RouteQueryOptions) => {
    return dateRate.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::dateRate
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:122
* @route '/rate-plans/date-rate'
*/
dateRate.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: dateRate.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::dateRate
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:122
* @route '/rate-plans/date-rate'
*/
const dateRateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: dateRate.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\RatePlanController::dateRate
* @see app/Http/Controllers/Admin/RatePlans/RatePlanController.php:122
* @route '/rate-plans/date-rate'
*/
dateRateForm.put = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: dateRate.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

dateRate.form = dateRateForm

/**
* @see \App\Http\Controllers\Admin\RatePlans\AiosellRatePlanMappingController::aiosellMapping
* @see app/Http/Controllers/Admin/RatePlans/AiosellRatePlanMappingController.php:30
* @route '/rate-plans/aiosell-mapping'
*/
export const aiosellMapping = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: aiosellMapping.url(options),
    method: 'get',
})

aiosellMapping.definition = {
    methods: ["get","head"],
    url: '/rate-plans/aiosell-mapping',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\RatePlans\AiosellRatePlanMappingController::aiosellMapping
* @see app/Http/Controllers/Admin/RatePlans/AiosellRatePlanMappingController.php:30
* @route '/rate-plans/aiosell-mapping'
*/
aiosellMapping.url = (options?: RouteQueryOptions) => {
    return aiosellMapping.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RatePlans\AiosellRatePlanMappingController::aiosellMapping
* @see app/Http/Controllers/Admin/RatePlans/AiosellRatePlanMappingController.php:30
* @route '/rate-plans/aiosell-mapping'
*/
aiosellMapping.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: aiosellMapping.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\AiosellRatePlanMappingController::aiosellMapping
* @see app/Http/Controllers/Admin/RatePlans/AiosellRatePlanMappingController.php:30
* @route '/rate-plans/aiosell-mapping'
*/
aiosellMapping.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: aiosellMapping.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\AiosellRatePlanMappingController::aiosellMapping
* @see app/Http/Controllers/Admin/RatePlans/AiosellRatePlanMappingController.php:30
* @route '/rate-plans/aiosell-mapping'
*/
const aiosellMappingForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: aiosellMapping.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\AiosellRatePlanMappingController::aiosellMapping
* @see app/Http/Controllers/Admin/RatePlans/AiosellRatePlanMappingController.php:30
* @route '/rate-plans/aiosell-mapping'
*/
aiosellMappingForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: aiosellMapping.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\AiosellRatePlanMappingController::aiosellMapping
* @see app/Http/Controllers/Admin/RatePlans/AiosellRatePlanMappingController.php:30
* @route '/rate-plans/aiosell-mapping'
*/
aiosellMappingForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: aiosellMapping.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

aiosellMapping.form = aiosellMappingForm

const ratePlans = {
    index: Object.assign(index, index),
    save: Object.assign(save, save),
    toggleActive: Object.assign(toggleActive, toggleActive),
    dateRate: Object.assign(dateRate, dateRate),
    aiosellMapping: Object.assign(aiosellMapping, aiosellMapping4f4b2d),
}

export default ratePlans